export const formatPhoneNumbers = (value: string) => {
  let input = value || '';
  input = input.replace(/\D/g, '');

  // Trim the remaining input to ten characters, to preserve phone number format
  input = input.substring(0, 10);

  const size = input.length;

  if (size === 0) {
    return input;
  }
  if (size < 4) {
    return `(${input}`;
  }
  if (size < 7) {
    return `(${input.substring(0, 3)}) ${input.substring(3, 6)}`;
  }

  return `(${input.substring(0, 3)}) ${input.substring(
    3,
    6,
  )} - ${input.substring(6, 10)}`;
};

export const removeNonDigits = (value: string) => value.replace(/\D/g, '');
